import { render, staticRenderFns } from "./comp_voice.vue?vue&type=template&id=17156a62&scoped=true"
import script from "./comp_voice.vue?vue&type=script&lang=js"
export * from "./comp_voice.vue?vue&type=script&lang=js"
import style0 from "./comp_voice.vue?vue&type=style&index=0&id=17156a62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17156a62",
  null
  
)

/* custom blocks */
import block0 from "./comp_voice.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports